import * as React from "react";
import { styled, Card, CardProps } from "@mui/material";

const ListItemCard: React.FC<CardProps> = (props) => {
  return <StyledListItemCard variant="outlined" {...props} />;
};

export default ListItemCard;

const StyledListItemCard = styled(Card)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderRadius: 0,
  boxSizing: "border-box",
  padding: `6px ${theme.spacing(2)}`,
  "&:first-of-type": {
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
  },
  "&:last-of-type": {
    borderBottomLeftRadius: 3,
    borderBottomRightRadius: 3,
  },
  "&:not(:first-of-type)": {
    borderTop: "none",
  },
}));
